import axios from 'axios'
import { getCsrfToken, getSessionToken } from '@futures-platform/connectors/session'

// Allow empty base URL (root-relative path) — handles both absolute (staging) and
// relative (production deployment) configurations gracefully.
const commentingBaseUrl = (process.env.REACT_APP_COMMENTING_API_URL || '').replace(/\/$/, '')

async function httpRequest(method, path, payload = null) {
  return axios({
    method,
    // If base URL is empty we build a root-relative path e.g. /commenting/{gid}/...
    url: commentingBaseUrl ? `${commentingBaseUrl}/${path}` : `/${path}`,
    headers: {
      'X-CSRF-Token': getCsrfToken(),
      'Content-Type': 'application/json',
      Authorization: `Bearer ${getSessionToken()}`,
    },
    withCredentials: true,
    data: payload || null,
  })
}

export const commentingApi = {
  /**
   * Fetch all comments for every phenomenon in a radar.
   * Each comment has: comment_id, uid, entity_uri, comment_text, comment_name, user_name
   * entity_uri format: commenting/{gid}/radar/{radarId}/phenomenon/{pid}/{section}
   *
   * GET {commentingBaseUrl}/commenting/{gid}/radar/{radarId}
   */
  getAllComments: async (gid, radarId) => {
    return httpRequest('GET', `commenting/${gid}/radar/${radarId}`)
  },

  /**
   * GET {commentingBaseUrl}/commenting/{gid}/radar/{radarId}/phenomenon/{phenId}
   */
  getAllCommentsByPhenId: async (gid, radarId, phenId) => {
    return httpRequest('GET', `commenting/${gid}/radar/${radarId}/phenomenon/${phenId}`)
  },

  /**
   * POST {commentingBaseUrl}/commenting/{gid}/radar/{radarId}/phenomenon/{pid}/{section}/{cmtId}
   */
  upsertComment: async (gid, radarId, pid, section, cmtId, payload) => {
    return httpRequest('POST', `commenting/${gid}/radar/${radarId}/phenomenon/${pid}/${section}/${cmtId}`, payload)
  },

  /**
   * DELETE {commentingBaseUrl}/commenting/{gid}/radar/{radarId}/phenomenon/{pid}/{section}/{cmtId}
   */
  deleteComment: async (gid, radarId, pid, section, cmtId) => {
    return httpRequest('DELETE', `commenting/${gid}/radar/${radarId}/phenomenon/${pid}/${section}/${cmtId}`)
  },

  /**
   * Fetch all comments by the current authenticated user for a radar.
   * Mirrors the voting/rating /user endpoint pattern.
   * GET {commentingBaseUrl}/commenting/{gid}/radar/{radarId}/user
   */
  getCommentsByCurrentUser: async (gid, radarId) => {
    return httpRequest('GET', `commenting/${gid}/radar/${radarId}/user`)
  },

  /**
   * Unique commenter counts split by user type — authoritative source for assessment summary.
   * GET {commentingBaseUrl}/commenting/{gid}/radar/{radarId}/comment-counts
   * Response: { normal_user_count, public_user_count }
   */
  getCommentCounts: async (gid, radarId) => {
    return httpRequest('GET', `commenting/${gid}/radar/${radarId}/comment-counts`)
  },
}
